import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SelectBoxImg = ({
  value_text = [], // array
  setvalue_text = [], // array
  array_list = [], // array
  setValidation, // string
  isMulti, // boolean
  isTextArea, // boolean
  types,
  ind,
  key_name,
  handleChange,
  code,
  edit,
}) => {
  const [dropDown, setDropDown] = useState(false);
  const [selectALL, setSelectALL] = useState(false);
  const [list, setList] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (array_list?.length > 0) {
      setList(array_list);
    }
  }, [array_list]);

  const allSelectSub = () => {
    let listId = [];
    let listName = [];
    if (selectALL) {
      array_list?.map((item, ind) => {
        listId.push(item?.id);
        listName.push(item);
        setValidation(item?.id);
      });
      setvalue_text(listName);
      if (types == "room") {
        handleChange(listName, ind, key_name);
      }

      if (types == "rooms") {
        handleChange(listName, key_name);
      }
    } else {
      setvalue_text(listName);
      if (types == "room") {
        handleChange(listName, ind, key_name);
      }

      if (types == "rooms") {
        handleChange(listName, key_name);
      }
    }
    setSearchValue("");
  };

  const searchSub = (event) => {
    let temp = [...array_list];
    let search = temp.filter((value) =>
      value?.name?.toLowerCase()?.includes(event?.toLowerCase())
    );

    if (event?.length > 0) {
      setList(search);
    } else {
      setList(array_list);
    }

    setSearchValue(event);
  };

  const onSubSelect = (event, type) => {
    if (isMulti) {
      let temp = [...value_text];

      let fin = temp?.find((i) => i?.id == event?.id);
      if (fin?.id) {
        let finder = temp?.filter((i) => i?.id !== event?.id);
        setvalue_text(finder);
        if (types == "room") {
          handleChange(finder, ind, key_name);
        }

        if (types == "rooms") {
          handleChange(finder, key_name);
        }
      } else {
        setvalue_text([...temp, event]);
        if (types == "room") {
          handleChange([...temp, event], ind, key_name);
        }

        if (types == "rooms") {
          handleChange([...temp, event], key_name);
        }
      }
    } else {
      let temp = [];

      let fin = temp?.find((i) => i?.id == event?.id);
      if (fin?.id) {
        let finder = temp?.filter((i) => i?.id !== event?.id);
        setvalue_text(finder);
        if (type == "room") {
          handleChange(finder, ind, key_name);
        }

        if (types == "rooms") {
          handleChange(finder, key_name);
        }
      } else {
        setvalue_text([...temp, event]);
        if (type == "room") {
          handleChange([...temp, event], ind, key_name);
        }

        if (types == "rooms") {
          handleChange([...temp, event], key_name);
        }
      }
    }

    if (type !== "check") {
      setDropDown(false);
    }

    setSearchValue("");
    setList(array_list);
    setValidation(event?.id);
  };

  return (
    <div className="position-relative">
      {isTextArea ? (
        <textarea
          placeholder="Select..."
          type="text"
          readOnly
          // value={
          //   value_text?.length > 0 ? value_text?.join(", ") : placeholder_text
          // }
          value={code == 'code' ? value_text?.[0]?.name : "Select..."}
          onClick={() => {
            setDropDown(!dropDown);
          }}
          className="input-pop w-100 cp rounded-3 p-2 w-90 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 p-cust"
        />
      ) : (
        <input
          placeholder="Select..."
          type="text"
          readOnly
          // value={
          //   value_text?.length > 0 ? value_text?.join(", ") : placeholder_text
          // }
          value={code == 'code' ? value_text?.[0]?.name : "Select..."}
          onClick={() => {
            setDropDown(!dropDown);
          }}
          className="input-pop w-100 cp rounded-3  p-2 w-90 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 p-cust"
          disabled={edit}
        />
      )}
      <button
        className="drop_down cust-btn"
        style={{ top: "0%" }}
        onClick={() => {
          setDropDown(!dropDown);
        }}
        disabled={edit}

      >

        <KeyboardArrowDownIcon />
      </button>
      {dropDown && (
        <div
          className="invisible-cont2 z-0"
          onClick={() => {
            setDropDown(false);
          }}
        />
      )}
      {!edit && dropDown && (<div
        className={`${dropDown ? "submenu_1 py-2" : ""
          } submenu_cont_1 overflow-scroll z-3`}
      >
        <div className="d-flex gap-1">
          <input
            className="d-flex ac-jb px-2 cust-btn text-start py-1 w-100 border-bottom rounded"
            placeholder="Search..."
            onChange={(e) => searchSub(e.target.value)}
            value={searchValue}
          />
          {isMulti ? (
            <button
              className="border-0 bg-transparent"
              onClick={() => {
                setSelectALL(!selectALL);
                allSelectSub();
              }}
            >
              All
            </button>
          ) : null}
        </div>
        {list?.map((item, ind) => {
          return (
            <button
              className="d-flex cust-btn w-100 as-jb hover-cust ac-jb"
              key={ind}
            >
              <button
                className="px-2 cust-btn text-start py-1 w-100 "
                onClick={() => {
                  onSubSelect(item);
                }}
              >
                {item?.name}
              </button>
              <button
                className="px-2 cust-btn text-start"
                style={{ fontSize: "large" }}
                onClick={() => {
                  onSubSelect(item, isMulti ? "check" : "");
                }}
              >
                {value_text?.find((i) => i?.id == item?.id) ? (
                  <CheckCircleIcon className="primary" />
                ) : (
                  <RadioButtonUncheckedIcon className="primary" />
                )}
              </button>
            </button>
          );
        })}
      </div>)}
    </div>
  );
};

export default SelectBoxImg;